/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { CollapsableSearchBox } from 'src/core/components/CollapsableSearchBox';
import { withDebouncedInput } from 'src/core/utils/hocs/withDebouncedInput';

/**
 * Represents a collapsible search box with local query state that does not
 * sync with the parent container until after a specified debounce
 * time value.
 */
export const LuisDebouncedCollapsableSearchBox = withDebouncedInput(CollapsableSearchBox);
